<template>
    <toolbar-option :message="message">
        <template slot="primary">
            <toggle :value="isEnabled" @input="onToggle" />

            <div v-show="isEnabled" class="option__multi">
                <span class="option__multi-label">
                    Anchor Element

                    <tooltip>
                        The element that the dropdown will "anchor" itself to when animating down. Note that you can get an element‘s ID by selecting the element, and then clicking on the fingerprint icon in its toolbar.
                    </tooltip>
                </span>

                <div v-if="isDynamicElement" class="option__input">
                    <dropdown
                        :value="target"
                        :options="targetOptions"
                        native
                        @input="onTargetInput"
                    />
                </div>

                <div v-if="target === 'custom'" class="option__input">
                    <input
                        type="text"
                        placeholder="Enter the element ID"
                        :value="targetId"
                        @input="onTargetIdInput"
                    >
                </div>
            </div>
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';

const TARGET_ATTR = 'dropdown-anchor';
// n.b. - this is store in a separate attribute, to make it easier for flex-deep-copy.js to process
const TARGET_ID_ATTR = 'dropdown-anchor-id';

export default {
    name: 'control-nav-dropdown-anchor',
    mixins: [baseOption],

    data() {
        return {
            displayName: 'Full Width Dropdown',
            isDynamicElement: false,
            isEnabled: false,
            message: '* turn on to extend the dropdown to the left/right edges of another element',
            target: 'self',
            targetId: '',

            targetOptions: [
                { text: 'Self', value: 'self' },
                { text: 'Parent', value: 'parent' },
                { text: 'Custom', value: 'custom' },
            ],
        };
    },

    watch: {
        changedOption({ option, value }) {
            if (option === 'nav-dropdown-direction' && value === 'right') {
                this.onConflict();
            }
        },
    },

    methods: {
        onToggle(isChecked) {
            if (isChecked) {
                this.selectedElements[0].setElementData(TARGET_ATTR, this.target);
            } else {
                this.selectedElements[0].removeElementData(TARGET_ATTR);
                this.selectedElements[0].removeElementData(TARGET_ID_ATTR);
            }

            this.isEnabled = isChecked;
            this.onChange({
                isEnabled: this.isEnabled,
                target: this.target,
                targetId: this.targetId,
            });
        },

        onTargetInput(targetValue) {
            this.target = targetValue;

            if (this.target !== 'custom') {
                const anchorElement = document.getElementById(this.targetId);

                if (anchorElement) {
                    anchorElement.style.removeProperty('transform');
                }
            }

            this.selectedElements[0].setElementData(TARGET_ATTR, this.target);
            this.selectedElements[0].removeElementData(TARGET_ID_ATTR);
            this.targetId = '';
            this.onChange({
                isEnabled: this.isEnabled,
                target: this.target,
                targetId: this.targetId,
            });
        },

        onTargetIdInput(e) {
            if (this.targetId) {
                const anchorElement = document.getElementById(this.targetId);

                if (anchorElement) {
                    anchorElement.style.removeProperty('transform');
                }
            }

            this.targetId = e.target.value;
            this.selectedElements[0].setElementData(TARGET_ID_ATTR, this.targetId);
            this.onChange({
                isEnabled: this.isEnabled,
                target: this.target,
                targetId: this.targetId,
            });
        },

        onSelectedElement() {
            const isEnabled = this.selectedElements[0].hasElementData(TARGET_ATTR);
            this.isDynamicElement = this.selectedElements[0].isDynamicElement;

            if (isEnabled) {
                const target = this.selectedElements[0].getElementData(TARGET_ATTR);
                const targetId = this.selectedElements[0].getElementData(TARGET_ID_ATTR);

                // guard against bad data
                if (!target) {
                    console.warn('[NAV DROPDOWN ANCHOR] Unable to load the custom attribute data. The required "target" field is missing.');
                    return;
                }

                this.target = target;
                this.targetId = targetId;
                this.isEnabled = isEnabled;

                // if the nav dropdown is NOT inside a collection, then the only available option is to pass a custom element ID for the anchor
            } else if (!this.isDynamicElement) {
                this.target = 'custom';
            }
        },

        onChange() {
            this.onOptionChange({
                isEnabled: this.isEnabled,
                target: this.target,
                targetId: this.targetId,
            });
        },

        onConflict() {
            this.selectedElements[0].removeElementData(TARGET_ATTR);
            this.selectedElements[0].removeElementData(TARGET_ID_ATTR);
            this.isEnabled = false;
        },
    },
};
</script>
